var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBreakfastFilled = function SvgHtlBreakfastFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.456 13.992a.5.5 0 0 1 0-1h11.035a.501.501 0 0 1 0 1H2.456Zm2.786-1.813A2.44 2.44 0 0 1 2.804 9.74V5.38a.5.5 0 0 1 .5-.5h8.238a2.442 2.442 0 0 1 2.438 2.438 2.442 2.442 0 0 1-2.423 2.438A2.441 2.441 0 0 1 9.12 12.18H5.242Zm6.314-3.424a1.438 1.438 0 0 0 0-2.875v2.875Zm-2.94-4.991V2.5a.5.5 0 0 1 1 0v1.263a.5.5 0 0 1-.854.355.5.5 0 0 1-.148-.354h.003Zm-1.936 0V2.5a.5.5 0 1 1 1 0v1.263a.5.5 0 0 1-1 0Zm-1.94 0V2.5a.5.5 0 0 1 1 0v1.263a.5.5 0 0 1-1 0Z"
  })));
};
export default SvgHtlBreakfastFilled;